import { v4 as uuidv4 } from 'uuid'
import service from '@/options/service'
import URL from '@/options/url'
import store from '@/options/store'
import { ElMessage } from 'element-plus'
import md5 from 'blueimp-md5'
// 处理需要递增逻辑
function plus(wordArr:number[]):void {
  const startChar = 'a'.charCodeAt(0)
  const endChar = 'z'.charCodeAt(0)

  let currIndex = 0
  while (true) {
    if (wordArr[currIndex] === undefined) {
      wordArr[currIndex] = startChar
      break
    } else {
      wordArr[currIndex] = wordArr[currIndex] + 1
      if (wordArr[currIndex] > endChar) {
        wordArr[currIndex] = startChar
        currIndex = currIndex + 1
      } else {
        break
      }
    }
  }
}
function getAllArr(num:number):string[] {
  const wordArr:number[] = []

  const allArr:string[] = []

  for (let i = 0; i < num; i++) {
    plus(wordArr)
    const abc:string = JSON.parse(JSON.stringify(wordArr))
      .reverse()
      .map((item:number) => {
        return String.fromCharCode(item)
      })
      .join('')
    allArr.push(abc)
  }
  return allArr
}
const limit = 100000
const allArr = getAllArr(limit)

export default {
  parseTime(time: string | number | Date, cFormat?: string, single?: boolean) {
    if (!time) {
      return ''
    }
    const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
    let date
    if (typeof time === 'object') {
      date = time
    } else {
      if (typeof time === 'string' && /^[0-9]+$/.test(time)) {
        time = parseInt(time)
      }
      if (typeof time === 'number' && time.toString().length === 10) {
        time = time * 1000
      }
      date = new Date(time)
    }
    const formatObj = {
      y: date.getFullYear(),
      m: date.getMonth() + 1,
      d: date.getDate(),
      h: date.getHours(),
      i: date.getMinutes(),
      s: date.getSeconds(),
      a: date.getDay()
    } as any
    const time_str = format.replace(
      /{(y|m|d|h|i|s|a)+}/g,
      (result, lable: string) => {
        let value = formatObj[lable]
        if (lable === 'a') {
          return ['日', '一', '二', '三', '四', '五', '六'][value]
        }
        if (!single && result.length > 0 && value < 10) {
          value = '0' + value
        }
        return value || 0
      }
    )
    return time_str
  },
  // 计算天数显示
  formatDateForStr(timeStr: string, option?: string, origin?: string) {
    if (timeStr) {
      const time = parseInt(timeStr)
      const date = new Date(time)
      const dateNum = date.getTime()
      const now = Date.now()
      const diff = (now - dateNum) / 1000
      const addZero = function(num: string | number) {
        return num <= 9 ? '0' + num : num
      }
      if (diff >= 0) {
        if (diff < 60) {
          return '刚刚'
        } else if (diff < 3600) {
          // less 1 hour
          return Math.ceil(diff / 60) + '分钟前'
        } else if (diff < 3600 * 6) {
          return Math.ceil(diff / 3600) + '小时前'
        } else if (diff < 3600 * 24) {
          const curDate =
            addZero(date.getDate()) === addZero(new Date().getDate())
              ? '今天'
              : '昨天'
          return (
            curDate +
            ' ' +
            addZero(date.getHours()) +
            ':' +
            addZero(date.getMinutes())
          )
        }
      }
      if (option) {
        return this.parseTime(time, option, false)
      } else {
        const formateDate = addZero(date.getFullYear()) + '-' + addZero(date.getMonth() + 1) + '-' + addZero(date.getDate())
        if (origin === 'docComment') {
          return formateDate
        } else {
          return (
            formateDate + ' ' + addZero(date.getHours()) + ':' + addZero(date.getMinutes()) + ':' + addZero(date.getSeconds())
          )
        }
      }
    }
    return ''
  },
  // 为某个元素添加水印
  addWaterMarker(
    containerEle: { appendChild: (arg0: HTMLDivElement) => void },
    waterText: string,
    style = {} as any // 改变水印样式开放参数
  ) {
    // 文档库水印标准
    const canvas = document.createElement('canvas')
    canvas.id = 'canvas'
    canvas.width = 300
    canvas.height = 180
    const ctx = canvas.getContext('2d')
    if (ctx) {
      ctx.clearRect(0, 0, canvas.width, canvas.height)
      ctx.font = 'normal 15px Microsoft Yahei'
      ctx.fillStyle = 'rgba(0,0,0,0.1)'
      ctx.translate(-canvas.width / 8, canvas.height / 2)
      ctx.rotate(-30 * Math.PI / 180)
      ctx.textBaseline = 'middle'
      ctx.textAlign = 'center'
      ctx.fillText(waterText, canvas.width / 2, canvas.height / 2)
      const src = canvas.toDataURL('image/png')
      // 水印容器
      const maskDiv = document.createElement('div')
      maskDiv.style.position = style.position ? style.position : 'absolute'
      maskDiv.style.zIndex = style.zIndex ? style.zIndex : '0'
      maskDiv.id = '_waterMark'
      maskDiv.style.top = '0px'
      maskDiv.style.left = '0px'
      maskDiv.style.width = '100%'
      maskDiv.style.height = '100%'
      maskDiv.style.marginTop = '0'
      maskDiv.style.pointerEvents = 'none'
      maskDiv.style.backgroundImage = 'URL(' + src + ')'
      // 水印节点插到指定id下
      containerEle.appendChild(maskDiv)
    }
  },
  // 在云图梭中打开新的页签
  openNewPage(url: string, id: string, fileType: number, title = '未命名文档', suffix?:string, jump?: string) {
    const a = document.createElement('a')
    a.setAttribute('href', url)
    a.setAttribute('target', '_blank')
    a.setAttribute('id', id)
    document.body.appendChild(a)
    a.click()
  },
  // 获取url参数
  getQueryVariable(url: string, key: any) {
    if (url) {
      const queryStr = url.split('?')[1]
      if (queryStr) {
        const vars = queryStr.split('&')
        for (let i = 0; i < vars.length; i++) {
          const pair = vars[i].split('=')
          if (pair[0] === key) {
            return pair[1]
          }
        }
        return false
      }
    }
    return false
  },
  // 数据容量转换
  bytesToSize(bytes: number) {
    bytes = Number(bytes)
    if (bytes) {
      const k = 1024
      const sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
      const i = Math.floor(Math.log(bytes) / Math.log(k))
      return (bytes / Math.pow(k, i)).toPrecision(3) + ' ' + sizes[i]
    } else {
      return '0 B'
    }
  },
  timestampToTime(timestamp: any) {
    const nowDate = new Date()
    const nowY = nowDate.getFullYear() + '年'
    const date = new Date(Number(timestamp))
    const Y = date.getFullYear() + '年'
    const Ystr = Y === nowY ? '' : Y
    const M =
      (date.getMonth() + 1 < 10
        ? '0' + (date.getMonth() + 1)
        : date.getMonth() + 1) + '月'
    const D =
      (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + '日  '
    const h =
      (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
    const m =
      date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
    const strDate = Ystr + M + D + h + m
    return strDate
  },
  // 获取浏览器类别及版本信息
  getUserAgentInfo() {
    const result = { name: '', version: 0 }
    const ua = navigator.userAgent.toLowerCase()
    const uaArr = ua.split(' ')
    if (ua.indexOf('edge') >= 0) { // Edge
      result.name = 'edge'
      uaArr.forEach(item => {
        if (item.indexOf('edge') >= 0) {
          const version = item.split('/')[1]
          result.version = Math.floor(Number.parseInt(version))
        }
      })
    } else if (ua.indexOf('chrome') > -1 && ua.indexOf('safari') > -1) { // chrome
      result.name = 'chrome'
      uaArr.forEach(item => {
        if (item.indexOf('chrome') >= 0) {
          const version = item.split('/')[1]
          result.version = Math.floor(Number.parseInt(version))
        }
      })
    } else if (ua.indexOf('safari') > -1 && ua.indexOf('chrome') === -1) { // safari
      result.name = 'safari'
      uaArr.forEach(item => {
        if (item.indexOf('version') >= 0) {
          const version = item.split('/')[1]
          result.version = Math.floor(Number.parseInt(version))
        }
      })
    }
    return result
  },
  // 返回传递给他的任意对象的类(返回：array、object、number、string)
  isClass(o: any): string {
    if (o === null) return 'Null'
    if (o === undefined) return 'Undefined'

    return Object.prototype.toString
      .call(o)
      .slice(8, -1)
      .toLowerCase()
  },
  hasScrollbar(element: HTMLElement): boolean {
    return element.scrollHeight > element.clientHeight
  },
  // 判断是不是Mac系统
  isMac(): boolean {
    return /macintosh|mac os x/i.test(navigator.userAgent)
  },
  // 深度克隆
  deepClone(obj: any) {
    let result: any
    const oClass = this.isClass(obj)

    // 确定result的类型
    if (oClass === 'object') {
      result = {}
    } else if (oClass === 'array') {
      result = []
    } else {
      return obj
    }
    for (const key in obj) {
      const copy = obj[key]
      if (this.isClass(copy) === 'object') {
        result[key] = this.deepClone(copy) // 递归调用
      } else if (this.isClass(copy) === 'array') {
        result[key] = this.deepClone(copy)
      } else {
        result[key] = obj[key]
      }
    }
    return result
  },
  // 数字转换为abc
  intToA(num:number):string {
    let index = num % limit - 1
    if (index < 0) {
      index = 0
    }
    return allArr[index]
  },
  copyToClipboard(word:string, type: 'copy' | 'cut' | 'paste'):void {
    if (type === 'paste') {
      document.execCommand(type)
      return
    }
    const tmpEl = document.createElement('div')
    tmpEl.style.opacity = '0'
    tmpEl.style.position = 'absolute'
    tmpEl.style.pointerEvents = 'none'
    tmpEl.style.zIndex = '-1'
    tmpEl.innerHTML = word
    document.body.appendChild(tmpEl)
    const range = document.createRange()
    range.selectNode(tmpEl)
    const selection = window.getSelection()
    if (selection) {
      selection.removeAllRanges()
      selection.addRange(range)
      document.execCommand(type)
      document.body.removeChild(tmpEl)
    }
  },
  // 文件类型
  fileType(type: string) {
    if (!type) {
      return 'document-folder'
    } else if (/dwg/i.test(type)) {
      return 'document-dwg'
    } else if (/(docx|doc)/i.test(type)) {
      return 'icon-word'
    } else if (/xlsx|xls/i.test(type)) {
      return 'icon-excel'
    } else if (/(ppt|pps|pot|ppa)/i.test(type)) {
      return 'document-ppt'
    } else if (/png|jpg|gif/i.test(type)) {
      return 'document-img'
    } else if (/rvt/i.test(type)) {
      return 'document-rvt'
    } else if (/(zip|rar)/i.test(type)) {
      return 'document-zip'
    } else if (/txt/i.test(type)) {
      return 'document-txt'
    } else if (/pdf/i.test(type)) {
      return 'document-pdf'
    } else if (/(flv|swf|ogg|mpeg4|mp4)/i.test(type)) {
      return 'document-video'
    } else {
      return 'document-other'
    }
  },
  isURL(strUrl:string):boolean {
    const regular = /^((http|https|ftp):\/\/)?[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&amp;:/~\+#]*[\w\-\@?^=%&amp;/~\+#])?/
    return regular.test(strUrl)
  },
  isDesktop() { // 是否是云图梭桌面端
    return /Electron/i.test(window.navigator.userAgent) && /YTS/i.test(window.navigator.userAgent)
  },
  isLXDesktop() { // 是否是龙信桌面端
    return /Electron/i.test(window.navigator.userAgent) && /LongChat/i.test(window.navigator.userAgent)
  },
  escape2Html(str: string) {
    const arrEntities: any = {
      lt: '<',
      gt: '>',
      nbsp: ' ',
      amp: '&',
      quot: '"'
    }
    return str.replace(/&(lt|gt|nbsp|amp|quot);/ig, function(all, i) { return arrEntities[i] })
  },
  createId():string {
    return uuidv4().replace('-', '').substring(0, 9)
  },
  // 反转义
  escapeText(text:string) {
    let temp:any = document.createElement('div')
    temp.innerHTML = text
    const output = temp.innerText || temp.textContent
    temp = null
    return output
  },
  // 解析传入的数字或者数字字符串或者百分比字符串的数字值
  getNumber(val:string|number):number {
    if (typeof val === 'number') {
      return val
    }
    if (typeof val === 'string') {
      const regex = /^(\d+\.\d+)%?$/
      const regex1 = /^(\d+\.)%?$/
      const regex2 = /^(\.\d+)%?$/
      const regex3 = /^(\d+)%?$/
      if (regex.test(val) || regex1.test(val) || regex2.test(val) || regex3.test(val)) {
        const tempNumber = Number.parseFloat(RegExp.$1)
        if (!Number.isNaN(tempNumber)) {
          if (val.endsWith('%')) {
            return tempNumber / 100
          } else {
            return tempNumber
          }
        }
      }
    }
    return Number.NaN
  },
  sort_ASCII(obj: any): any {
    const arr = []
    let num = 0
    for (const i in obj) {
      arr[num] = i
      num++
    }
    arr.sort()
    const sortObj = {} as any
    for (const j in arr) {
      sortObj[arr[j]] = obj[arr[j]]
    }
    return sortObj
  },
  isPercentage(val:string):boolean {
    const regex = /^(\d+\.\d+)%$/
    const regex1 = /^(\d+\.)%$/
    const regex2 = /^(\.\d+)%$/
    const regex3 = /^(\d+)%$/
    if (regex.test(val) || regex1.test(val) || regex2.test(val) || regex3.test(val)) {
      return true
    } else {
      return false
    }
  },
  debounceLast(fn:any, wait:any) {
    let timer:any
    return (...args:any) => {
      if (timer) {
        clearTimeout(timer)
        timer = null
      }
      timer = setTimeout(() => {
        fn.apply(this, args)
      }, wait)
    }
  },
  // 判断是否是有效数字
  isNumeric(value: any, type = 'decimalValues'): boolean {
    const numericRegexMap: Record<string, RegExp> = {
      decimalValues: /^-?\d+(\.\d{1,})?$/,
      wholeNumber: /^-?\d+?$/,
      oneDecimalPlace: /^-?\d+(\.\d{1,1})?$/,
      twoDecimalPlaces: /^-?\d+(\.\d{1,2})?$/,
      threeDecimalPlaces: /^-?\d+(\.\d{1,3})?$/
    }
    return numericRegexMap[type].test(value)
  },
  isNumericFormula(cell: string, type = 'decimalValues'): string {
    const numericFormulaRegexMap: Record<string, string> = {
      decimalValues: `ISNUMBER(${cell})`,
      wholeNumber: `INT(${cell})=${cell}`,
      oneDecimalPlace: `TRUNC(${cell},1)=${cell}`,
      twoDecimalPlaces: `TRUNC(${cell},2)=${cell}`,
      threeDecimalPlaces: `TRUNC(${cell},3)=${cell}`
    }

    return `=${numericFormulaRegexMap[type]}`
  },
  // 获取Date类型日期数据
  getDateStr(strDate:string):string {
    let date = ''
    if (this.isDate(strDate)) {
      const st = strDate + ''
      const currDate = new Date()

      let isNianyue = false
      let hasTime = false
      let onlyHasTime = false

      let tagWord = ''
      if (st.indexOf('-') > 0) {
        tagWord = '-'
        if (st.indexOf(':') > 0) {
          hasTime = true
        }
      } else if (st.indexOf('/') > 0) {
        tagWord = '/'
        if (st.indexOf(':') > 0) {
          hasTime = true
        }
      } else if (st.indexOf('月') > 0) {
        isNianyue = true
        if (st.indexOf(':') > 0) {
          hasTime = true
        }
      } else if (st.indexOf(':') > 0) {
        onlyHasTime = true
      }
      const strArr = st.split(' ')
      if (!strArr[0]) {
        strArr[0] = ''
      }
      const part1 = strArr[0]
      let year, month, day
      if (!isNianyue && tagWord) {
        const part1Arr = part1.split(tagWord)
        if (part1Arr[0].length !== 4) {
          part1Arr.unshift(currDate.getFullYear() + '')
        }
        year = Number.parseInt(part1Arr[0])
        month = Number.parseInt(part1Arr[1]) - 1
        day = Number.parseInt(part1Arr[2])
      } else {
        const nianIndex = st.indexOf('年')
        const yueIndex = st.indexOf('月')
        const riIndex = st.indexOf('日')

        if (nianIndex > 0) {
          year = Number.parseInt(part1.substring(0, nianIndex))
        }
        if (yueIndex > 0) {
          month = Number.parseInt(part1.substring(nianIndex + 1, yueIndex)) - 1
        }
        if (riIndex > 0) {
          day = Number.parseInt(part1.substring(yueIndex + 1, riIndex))
        }
      }
      if (!year) {
        year = currDate.getFullYear()
      }
      if (month !== 0 && !month) {
        month = currDate.getMonth()
      }
      if (!day) {
        day = currDate.getDate()
      }
      const newDate = new Date(year, month, day)
      date = this.parseTime(newDate, '{yyyy}/{mm}/{dd}', false)
      if (hasTime || onlyHasTime) {
        let timeArr: string[] = []
        if (hasTime) {
          const st1 = st.replace('T', ' ').replace('Z', '')
          timeArr = st1.split(' ')[1].split(':')
        }
        if (onlyHasTime) {
          timeArr = st.split(':')
        }
        const hour = Number.parseInt(timeArr[0]) || 0
        const minute = Number.parseInt(timeArr[1]) || 0
        const second = Number.parseInt(timeArr[2]) || 0
        newDate.setHours(hour)
        newDate.setMinutes(minute)
        newDate.setSeconds(second)
        date = this.parseTime(newDate, '{yyyy}/{mm}/{dd} {hh}:{ii}:{ss}', false)
      }
    }
    return date
  },
  defaultDateFormat(strDate = '', concatYear = false): string {
    const date = concatYear ? `${new Date().getFullYear()}/${strDate}` : strDate
    return date.replace(/-|年|月|日/g, '/').replace(/\/+$/g, '')
  },
  advanceDateValidator(strDate: string): boolean { // 进入这一步只能说明日期格式是正确的，但还需要校验是否和万年历规则相同
    const dtArray = strDate.match(/^(\d{1,4})(\/)(\d{1,2})(\/)(\d{1,2})/) ?? []
    const dtYear = parseInt(dtArray[1])
    const dtMonth = parseInt(dtArray[3])
    const dtDay = parseInt(dtArray[5])

    if (dtMonth < 1 || dtMonth > 12)
      return false
    else if (dtDay < 1 || dtDay > 31)
      return false
    else if ((dtMonth === 4 || dtMonth === 6 || dtMonth === 9 || dtMonth === 11) && dtDay === 31)
      return false
    else if (dtMonth === 2) {
      const isleap = (dtYear % 4 === 0 && (dtYear % 100 !== 0 || dtYear % 400 === 0))
      if (dtDay > 29 || (dtDay === 29 && !isleap)) return false
    }

    const date = new Date(strDate)
    return date.toString() !== 'Invalid Date'
  },
  // 判断是否是有效日期
  isDate(strDate = ''): boolean {
    const reg1 = /^(\d{1,4})(年)(\d{1,2})(月)(\d{1,2})(日)$/
    const case1 = reg1.test(strDate)

    const reg11 = /^(\d{1,4})(年)(\d{1,2})(月)$/
    const case11 = reg11.test(strDate)

    const reg12 = /^(\d{1,2})(月)(\d{1,2})(日)$/
    const case12 = reg12.test(strDate)

    const reg2 = /^([0-2]{0,1}[0-9]{1})(:)([0-6]{1}[0-9]{1})$/
    const case2 = reg2.test(strDate)

    const reg3 = /^(\d{1,4})(-)(\d{1,2})(-)(\d{1,2})/
    const case3 = reg3.test(strDate)

    const reg31 = /^(\d{1,4})(-)(\d{1,2})/
    const case31 = reg31.test(strDate)

    const reg32 = /^(\d{1,2})(-)(\d{1,2})/
    const case32 = reg32.test(strDate)

    const reg4 = /^(\d{1,4})(\/)(\d{1,2})(\/)(\d{1,2})/
    const case4 = reg4.test(strDate)

    const reg41 = /^(\d{1,4})(\/)(\d{1,2})/
    const case41 = reg41.test(strDate)

    const reg42 = /^(\d{1,2})(\/)(\d{1,2})/
    const case42 = reg42.test(strDate)

    const isFullDate = case1 || case2 || case3 || case4
    const isShortDate = case11 || case12 || case31 || case32 || case41 || case42
    const isDateFormat = isFullDate || isShortDate

    return isDateFormat ? this.advanceDateValidator(this.defaultDateFormat(strDate, !isFullDate && isShortDate)) : false
  },
  transformSignFromCnToEn(str: string): string {
    const signMap: Record<string, string> = {
      '（': '(', // \uff08
      '）': ')', // \uff09
      '。': '.', // \u3002
      '？': '?', // \uff1f
      '！': '!', // \uff0c
      '，': ',', // \u3001
      '；': ';', // \uff1b
      '：': ':' // \uff1a
    }
    return str.replace(/\uff08|\uff09|\u3002|\uff1f|\uff0c|\u3001|\uff1b|\uff1a/ig, (u: string): string => signMap[u])
  },
  getLastSegmentOfUrl(path = ''): string {
    if (path.charAt(path.length - 1) === '/') {
      path = path.slice(0, -1)
    }
    return path.substring(path.lastIndexOf('/') + 1)
  },
  getActualRange(sheet: any, range: any) {
    let row = range.row
    let rowCount = range.rowCount
    let col = range.col
    let colCount = range.colCount

    if (row === -1) {
      row = 0
      rowCount = sheet.getRowCount()
    }

    if (col === -1) {
      col = 0
      colCount = sheet.getColumnCount()
    }

    return new window.GC.Spread.Sheets.Range(row, col, rowCount, colCount)
  },
  // 后端记录日志接口
  setDocOperateLog(operateType: number, result: boolean, startTime: number, params = '') {
    const endTime = new Date().getTime()
    service.post(URL.setDocOperateLog, { fileId: store.state.docInfo.fileId, operateType, result, startTime, endTime, params})
  },
  // 复制权限控制
  copyPermissionControl(): void {
    const ctrlKey = 17
    const cmdKey = 91
    const cKey = 67
    // const vKey = 86
    let ctrlDown = false
    window.onkeydown = (e: KeyboardEvent): boolean | void => {
      if (e.keyCode === ctrlKey || e.keyCode === cmdKey) {
        ctrlDown = true
      }

      // 只限制原生复制，可编辑状态下的粘贴功能需要打开
      if (ctrlDown && (e.keyCode === cKey)) {
        ElMessage.warning('您没有权限复制文档内容')
        return false
      }
    }

    window.onkeyup = (e: KeyboardEvent): void => {
      if (e.keyCode === ctrlKey || e.keyCode === cmdKey) {
        ctrlDown = false
      }
    }
    window.onselectstart = () => {
      return false
    }
  },
  docOnlineNewsPush(params:any):any {
    const doclib = {...params, systemCode: store.state.docInfo.systemCode}
    const ascObj = this.sort_ASCII(doclib)
    let ascStr = ''
    for (const i in ascObj) {
      ascStr += (i + '=' + ascObj[i] + '&')
    }
    ascStr = ascStr.slice(0, -1)
    const sign = md5(ascStr).toUpperCase()
    const lastSign = md5(sign + doclib.fileId).toUpperCase()
    return service.post(URL.docOnlineNewsPush, {...doclib, sign: lastSign})
  },
  // 查找父节点(不包含当前节点)
  getAllParentNodes(list:any, id:any, mapKeys:any) {
    for (const i in list) {
      if (list[i][mapKeys.id] === id) {
        return [list[i]].filter(v => v[mapKeys.id] !== id)
      }
      if (list[i].children?.length > 0) {
        const node:any = this.getAllParentNodes(list[i].children, id, mapKeys)
        if (node) return node.concat(list[i]).filter((v:any) => { return v[mapKeys.id] !== id })
      }
    }
  },
  // 查找父节点(包含当前节点)
  findAncestorsById(tree:any, id:any, result:any = [], mapKeys:any) {
    for (const node of tree) {
      if (node[mapKeys.id] === id) {
        result.push(node)
        return result
      }
      if (node.children.length) {
        const temp = this.findAncestorsById(node.children, id, result, mapKeys)
        if (temp) {
          result.push(node)
          return result
        }
      }
    }
    return null
  }
}
